import React from 'react'
import styled from 'styled-components'
import { AiOutlineCloseSquare } from 'react-icons/ai'
import { format_date } from '../../utils'

/**
 * A shared component to display order details in a popup
 * Used by both admin and customer-facing screens
 */
const OrderDetails = ({ order, onClose, isSubscription = false }) => {
  if (!order) return null

  const label = isSubscription ? 'Abonnement' : 'Ordre'

  return (
    <OrderDetailsContainer>
      <OrderDetailsHeader>
        <div><b>Dato:</b> {format_date(new Date(order?.created_at))}</div>
        <div><b>{label}:</b> {order.id.split('-')[0]}</div>
        {!isSubscription && <div><b>Status:</b> {order?.data?.status}</div>}
        {order.subscription && !isSubscription && (
          <div><b>Abonnement:</b> {order.subscription.split('-')[0]}</div>
        )}
        {isSubscription && order?.data?.frequency && (
          <div><b>Frekvens:</b> {order?.data?.frequency}</div>
        )}
        {isSubscription && order?.data?.last_order_date && (
          <div><b>Siste bestilling:</b> {new Date(order?.data?.last_order_date).toLocaleDateString()}</div>
        )}
      </OrderDetailsHeader>
      
      {order.data.products.map((product, index) => (
        <ProductDetailsContainer key={`${product.id}-${index}`}>
          <ProductItem size={50}>
            <img src={isSubscription ? product?.data?.bag : product?.orig?.data?.bag} alt={product?.data?.name || 'Kaffepose'} />
          </ProductItem>
          <ProductDetails>
            <div className="name">{product?.data?.name}</div>
            <div className="grind">{product?.grind}</div>
          </ProductDetails>
        </ProductDetailsContainer>
      ))}
      
      <ProductDetailsClose>
        <AiOutlineCloseSquare size="1.5em" onClick={onClose} />
      </ProductDetailsClose>
    </OrderDetailsContainer>
  )
}

const OrderDetailsContainer = styled.div`
  position: fixed;
  width: 90%;
  max-width: 300px;
  top: 50%;
  left: 50%;
  border: 1px solid black;
  transform: translate(-50%, -50%);
  z-index: 2;
  background-color: var(--color-splash-yellow);
  padding: 2%;
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: 768px) {
    width: 85%;
    max-width: 260px;
    padding: 10px;
    font-size: 0.9em;
  }
`

const OrderDetailsHeader = styled.div`
  font-family: monospace;
  margin-top: 25px;
  margin-bottom: 10px; 
  & b {
    margin-right: 10px;
  }
  
  @media (max-width: 768px) {
    font-size: 0.9em;
    
    & div {
      margin-bottom: 3px;
    }
  }

  display: flex;
  flex-direction: column;

  & div {
    display: flex;
    justify-content: space-between;
  }
`

const ProductDetailsContainer = styled.div`
  position: relative;
  display: flex;
  gap: 10px;
  
  @media (max-width: 768px) {
    gap: 5px;
  }
`

const ProductItem = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  & img {
    width: ${props => `${props?.size || 80}px`};
    border: 1px solid black;
    
    @media (max-width: 768px) {
      width: ${props => `${props?.size || 57}px`};
    }
  }
`

const ProductDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;

  & div.name {
    font-weight: bold;
  }

  & div.grind {
    text-transform: capitalize;
  }

  & p {
    font-size: 0.9em;
  }
  
  @media (max-width: 768px) {
    gap: 3px;
    font-size: 0.9em;
    
    & div.name {
      font-size: 0.95em;
    }
    
    & p {
      font-size: 0.8em;
    }
  }
`

const ProductDetailsClose = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
`

export default OrderDetails
